import { StyledTable } from './styles';

export default function Table({ columns, data, rowKey, ...rest }) {
  return (
    <StyledTable {...rest}>
      <thead>
        <tr>
          {columns.map((column) => (
            <th style={column.style} key={column.dataIndex}>
              {column.name.toUpperCase()}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {data.map((row, index) => (
          <tr key={row[rowKey]}>
            {columns.map((column) => (
              <td key={column.dataIndex}>{column.render?.(row[column.dataIndex], row, index) || row[column.dataIndex]}</td>
            ))}
          </tr>
        ))}
      </tbody>
    </StyledTable>
  );
}
